import React, { useState } from 'react'
import PropagateLoader from "react-spinners/PropagateLoader";
import { useSelector } from 'react-redux';
import DataTables from '../LMS_DATA_TABLE/DataTable';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

export default function GroupDetails(props) {

    const { detailModal, setDetailModal, modalLoading, setModalLoading } = props;
    const details = useSelector(state => state.groupDetails && state.groupDetails.data && state.groupDetails.data.data && state.groupDetails.data.data[0])
    const data = useSelector(state => state.groupDetails && state.groupDetails.data && state.groupDetails.data.data && state.groupDetails.data.data[0] && state.groupDetails.data.data[0].lms_group_sub_schemas)

    const columnDefs = [
        {
            headerName: details && details.group_name + ' (' + new Date(details && details.createdAt).toLocaleDateString('en-GB') + ')',
            children: [
                {
                    headerName: 'NAME',
                    field: 'vemp_name',
                    filter: 'agTextColumnFilter',
                    suppressMenu: true,
                    sortable: true,
                    floatingFilter: true,
                    // wrapText: true,
                    // autoHeight: true,
                },
                {
                    headerName: 'ID',
                    field: 'vemp_company_code',
                    filter: 'agTextColumnFilter',
                    suppressMenu: true,
                    filter: true,
                    sortable: true,
                    floatingFilter: true,
                    // wrapText: true,
                    // autoHeight: true,
                },
                // {
                //     headerName: 'DEPARTMENT',
                //     field: 'department_name',
                //     filter: 'agTextColumnFilter',
                //     suppressMenu: true,
                //     filter: true,
                //     sortable: true,
                //     floatingFilter: true,
                //     // wrapText: true,
                //     // autoHeight: true,
                // },
                {
                    headerName: 'DESIGNATION',
                    field: 'designation_name',
                    filter: 'agTextColumnFilter',
                    suppressMenu: true,
                    filter: true,
                    sortable: true,
                    floatingFilter: true,
                    // wrapText: true,
                    // autoHeight: true,
                },
                {
                    headerName: 'EMAIL',
                    field: 'user_email',
                    filter: 'agTextColumnFilter',
                    suppressMenu: true,
                    filter: true,
                    sortable: true,
                    floatingFilter: true,
                    // wrapText: true,
                    // autoHeight: true,
                },
                {
                    headerName: 'PHONE NO.',
                    field: 'mobile_num',
                    filter: 'agTextColumnFilter',
                    suppressMenu: true,
                    filter: true,
                    sortable: true,
                    floatingFilter: true,
                    // wrapText: true,
                    // autoHeight: true,
                },
            ]
        }
    ];

    return (
        <>
            <div className={detailModal ? 'modal fade show d-block' : 'modal fade show d-none'} style={{ background: 'rgba(0,0,0,0.8)' }}>
                <div className="modal-dialog modal-dialog-centered modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Group Details</h5>
                            <button type="button" className="btn-close" style={{ boxShadow: 'none' }} onClick={() => { setDetailModal(false); setModalLoading(true) }}></button>
                        </div>

                        {modalLoading ?
                            <div className="modal-body">
                                <div className='text-center mb-3'>
                                    <PropagateLoader
                                        color="#2262C6"
                                        size={20}
                                    />
                                </div>
                            </div>
                            :
                            <div className="modal-body">
                                <div className="d-lg-flex justify-content-between">
                                    <div>
                                        <div className='d-flex align-items-baseline'>
                                            <span style={{ color: '#9d9d9d' }}>Group Name:</span>
                                            <h6 className='ms-2'>{details && details.group_name}</h6>
                                        </div>
                                        <div className='d-flex align-items-baseline'>
                                            <span style={{ color: '#9d9d9d' }}>Created On:</span>
                                            <h6 className='ms-2'>{new Date(details && details.createdAt).toDateString()}</h6>
                                        </div>
                                    </div>

                                    <div>
                                        <div className='d-flex align-items-baseline'>
                                            <span style={{ color: '#9d9d9d' }}>Updated By:</span>
                                            <h6 className='ms-2'>{details && details.updated_by}</h6>
                                        </div>
                                        <div className='d-flex align-items-baseline mb-2'>
                                            <span style={{ color: '#9d9d9d' }}>Updated On:</span>
                                            <h6 className='ms-2'>{new Date(details && details.updatedAt).toDateString()}</h6>
                                        </div>
                                    </div>
                                </div>

                                {/* <Tabs
                                    defaultActiveKey="user"
                                    id="fill-tab-example"
                                    className="piils_btn mb-3"
                                    fill
                                > */}
                                {/* <Tab eventKey="user" title="User List"> */}
                                <span style={{ color: '#9d9d9d' }}>Users:</span>
                                <div className='mt-2'>
                                    <DataTables
                                        rowData={data}
                                        columnDefs={columnDefs}
                                        height='45vh'
                                    />
                                </div>
                                {/* </Tab> */}

                                {/* <Tab eventKey="training" title="Training List">
                                        <div className='text-center text-danger'>
                                            <span>Training List Data is static now</span>
                                        </div>
                                        <DataTables
                                            rowData={data}
                                            columnDefs={columnDefs}
                                            height='45vh'
                                        />
                                    </Tab> */}

                                {/* </Tabs> */}

                            </div>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}
